﻿<template>
  <el-dialog
    :visible.sync="visible"
    width="650px"
    top="21vh"
    custom-class="figma-community-dialog"
    :show-close="false"
    :close-on-click-modal="false"
    @close="refreshEditCommunityInfo"
  >
    <div slot="title" class="figma-dialog-header">
      <span class="figma-dialog-title">{{ $t('editCommunity.title') }}</span>
      <img src="../../../assets/CodeBuddyAssets/616_12573/31.svg" class="figma-dialog-divider" />
    </div>

    <el-form ref="form" :model="editCommunityInfo" :rules="rules" label-width="86px" class="figma-community-form" size="small">
      <el-form-item :label="$t('editCommunity.name') + ':'" prop="name">
        <el-input v-model="editCommunityInfo.name" :placeholder="$t('editCommunity.namePlaceholder')" class="figma-form-input" disabled />
      </el-form-item>
      <el-form-item :label="$t('addCommunity.province') + ':'" prop="provinceCode" required>
        <el-select v-model="editCommunityInfo.provinceCode" :placeholder="$t('addCommunity.selectPlaceholder')" class="figma-form-input" @change="handleProvChange">
          <el-option v-for="item in areaOptions.provs" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addCommunity.city') + ':'" prop="cityCode" required>
        <el-select v-model="editCommunityInfo.cityCode" :placeholder="$t('addCommunity.selectPlaceholder')" class="figma-form-input" :disabled="!editCommunityInfo.provinceCode" @change="handleCityChange">
          <el-option v-for="item in areaOptions.citys" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('addCommunity.areaName') + ':'" prop="districtCode" required>
        <el-select v-model="editCommunityInfo.districtCode" :placeholder="$t('addCommunity.selectPlaceholder')" class="figma-form-input" :disabled="!editCommunityInfo.cityCode" @change="handleAreaChange">
          <el-option v-for="item in areaOptions.areas" :key="item.areaCode" :label="item.areaName" :value="item.areaCode" />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('editCommunity.address') + ':'" prop="address">
        <el-input v-model="editCommunityInfo.address" :placeholder="$t('editCommunity.addressPlaceholder')" class="figma-form-input" />
      </el-form-item>
      <!-- <el-form-item :label="$t('addCommunity.status') + ':'" prop="isOpen" required class="figma-status-form-item">
        <el-radio-group v-model="editCommunityInfo.isOpen" class="figma-status-radio">
          <el-radio label="1">{{ $t('communityManage.search.stateNormal') }}</el-radio>
          <el-radio label="0">{{ $t('communityManage.search.stateDisabled') }}</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <el-form-item v-for="(item, index) in editCommunityInfo.attrs" :key="index" :label="item.specName + ':'"
        :prop="'attrs.' + index + '.value'">
        <el-input v-if="item.specType === '2233'" v-model="item.value" :placeholder="item.specHoldplace" class="figma-form-input" />
        <el-select v-else-if="item.specType === '3344'" v-model="item.value" :placeholder="item.specHoldplace"
          class="figma-form-input">
          <el-option v-for="value in item.values" :key="value.value" :label="value.valueName" :value="value.value" />
        </el-select>
      </el-form-item>


      <el-form-item
        :label="$t('editCommunity.voteReminder') + ':'"
        prop="voteReminder"
      >
        <el-switch
          v-model="editCommunityInfo.voteReminder"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="Y"
          inactive-value="N"
        >
        </el-switch>
      </el-form-item>
    </el-form>

    <div slot="footer" class="figma-dialog-footer">
      <el-button size="small" class="figma-btn-cancel" @click="visible = false">{{ $t('common.cancel') }}</el-button>
      <el-button size="small" class="figma-btn-confirm" @click="editCommunity">{{ $t('common.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateCommunity, listAreas } from '@/api/community/communityManageApi'
import { getAttrSpecList } from '@/api/dev/attrSpecApi'
import { getAttrValueList } from '@/api/dev/attrValueApi'

export default {
  name: 'EditCommunity',
  data() {
    return {
      visible: false,
      rules: {
        name: [
          { required: true, message: this.$t('editCommunity.validate.name'), trigger: 'blur' }
        ],
        provinceCode: [
          { required: true, message: this.$t('addCommunity.validate.province'), trigger: 'change' }
        ],
        cityCode: [
          { required: true, message: this.$t('addCommunity.validate.city'), trigger: 'change' }
        ],
        districtCode: [
          { required: true, message: this.$t('addCommunity.validate.area'), trigger: 'change' }
        ]
      },
      areaOptions: {
        provs: [],
        citys: [],
        areas: []
      },
      editCommunityInfo: this.getDefaultCommunityInfo()
    }
  },

  methods: {
    getDefaultCommunityInfo() {
      return {
        communityId: '',
        name: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        districtCode: '',
        districtName: '',
        idCard: '',
        isOpen: '1',
        address: '',
        nearbyLandmarks: '',
        mapX: '101.33',
        mapY: '101.33',
        payFeeMonth: 12,
        feePrice: 0,
        tel: '',
        attrs: [],
        voteReminder: 'N',
      }
    },
    async openModal(community) {
      this.refreshEditCommunityInfo()
      const normalizedData = this.normalizeCommunityFields(community)
      this.editCommunityInfo.provinceCode = normalizedData.provinceCode
      this.editCommunityInfo.cityCode = normalizedData.cityCode
      this.editCommunityInfo.districtCode = normalizedData.districtCode
      await this.initAreaOptions()
      Object.assign(this.editCommunityInfo, normalizedData)
      await this._loadEditCommunityAttrSpec()
      this.visible = true

      if (!community.communityAttrDtos) {
        return
      }
      const attrDtos = community.communityAttrDtos
      const attrs = this.editCommunityInfo.attrs

      attrDtos.forEach(item => {
        attrs.forEach(attrItem => {
          if (item.specCd == attrItem.specCd) {
            attrItem.attrId = item.attrId
            attrItem.value = item.value
          }
        })
      })
    },
    normalizeCommunityFields(community) {
      return {
        ...community,
        provinceCode: community.provinceCode || community.provCode || '',
        provinceName: community.provinceName || community.provName || '',
        cityCode: community.cityCode || '',
        cityName: community.cityName || '',
        districtCode: community.districtCode || community.areaCode || '',
        districtName: community.districtName || community.areaName || '',
        idCard: community.idCard || '',
        isOpen: this.getStatusCd(community),
        voteReminder: this.getVoteReminderVal(community)
      }
    },
    getVoteReminderVal(community) {
      const val = community.voteReminder !== undefined ? community.voteReminder : (community.vote_reminder !== undefined ? community.vote_reminder : (community.Urgetickets !== undefined ? community.Urgetickets : 'N'))
      if (val === 'Y' || val === 'y' || val === true || val === 1 || val === 'true') return 'Y'
      return 'N'
    },
    getStatusCd(community) {
      const isOpen = community.isOpen !== undefined ? community.isOpen : community.is_open
      if (isOpen !== undefined && isOpen !== null && isOpen !== '') {
        if (isOpen === true || String(isOpen).toLowerCase() === 'true') return '1'
        if (isOpen === false || String(isOpen).toLowerCase() === 'false') return '0'
        return String(isOpen)
      }
      const statusCd = community.status_cd !== undefined ? community.status_cd : community.statusCd
      if (statusCd !== undefined && statusCd !== null && statusCd !== '') {
        return String(statusCd)
      }
      if (community.state === '1200') {
        return '0'
      }
      return '1'
    },
    editCommunity() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const data = this.buildSubmitParams()
        updateCommunity(data).then((res) => {
          this.$message.success(this.$t('common.operationSuccess'))
          this.visible = false
          const communityId = data.communityId || (res && res.communityId) || ''
          this.$emit('listData', { communityId, voteReminder: data.voteReminder, isNew: false })
        }).catch(error => {
          this.$message.error(error.message)
        })
      })
    },
    buildSubmitParams() {
      const params = { ...this.editCommunityInfo }
      delete params.provCode
      delete params.provName
      delete params.areaCode
      delete params.areaName
      delete params.adminUsers
      delete params.adminUserIds
      delete params.adminUserId
      delete params.adminId
      delete params.adminIds
      delete params.adminNames
      delete params.adminName
      delete params.contactName
      delete params.userId
      delete params.userIds
      delete params.userName
      delete params.userNames
      delete params.storeName
      delete params.state
      delete params.statusCd
      delete params.status_cd
      return params
    },
    refreshEditCommunityInfo() {
      const attrs = this.editCommunityInfo && this.editCommunityInfo.attrs ? this.editCommunityInfo.attrs : []
      this.editCommunityInfo = {
        ...this.getDefaultCommunityInfo(),
        attrs
      }
      this.areaOptions.citys = []
      this.areaOptions.areas = []
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate()
      })
    },
    async initAreaOptions() {
      await this.loadAreas('101', '0', 'provs')
      if (this.editCommunityInfo.provinceCode) {
        await this.loadAreas('202', this.editCommunityInfo.provinceCode, 'citys')
      }
      if (this.editCommunityInfo.cityCode) {
        await this.loadAreas('303', this.editCommunityInfo.cityCode, 'areas')
      }
    },
    async loadAreas(areaLevel, parentAreaCode, key) {
      try {
        const res = await listAreas({ areaLevel, parentAreaCode })
        this.areaOptions[key] = res.areas || []
      } catch (error) {
        console.error('查询地区失败', error)
        this.$message.error(this.$t('areaSelect.fetchError'))
      }
    },
    handleProvChange(value) {
      const current = this.areaOptions.provs.find(item => item.areaCode === value)
      this.editCommunityInfo.provinceName = current ? current.areaName : ''
      this.editCommunityInfo.cityCode = ''
      this.editCommunityInfo.cityName = ''
      this.editCommunityInfo.districtCode = ''
      this.editCommunityInfo.districtName = ''
      this.areaOptions.citys = []
      this.areaOptions.areas = []
      if (value) this.loadAreas('202', value, 'citys')
    },
    handleCityChange(value) {
      const current = this.areaOptions.citys.find(item => item.areaCode === value)
      this.editCommunityInfo.cityName = current ? current.areaName : ''
      this.editCommunityInfo.districtCode = ''
      this.editCommunityInfo.districtName = ''
      this.areaOptions.areas = []
      if (value) this.loadAreas('303', value, 'areas')
    },
    handleAreaChange(value) {
      const current = this.areaOptions.areas.find(item => item.areaCode === value)
      this.editCommunityInfo.districtName = current ? current.areaName : ''
    },
    async _loadEditCommunityAttrSpec() {
      this.editCommunityInfo.attrs = []
      const { data } = await getAttrSpecList({
        page: 1,
        row: 100,
        tableName: 'building_community_attr'
      })
      data.forEach(item => {
        item.value = ''
        item.values = []
        this._loadEditAttrValue(item.specCd, item.values)
        if (item.specShow == 'Y' && !this.shouldHideEditAttr(item)) {
          this.editCommunityInfo.attrs.push(item)
        }
      })
    },
    shouldHideEditAttr(item) {
      const text = [
        item && item.specName,
        item && item.specCdName,
        item && item.specHoldplace
      ].filter(Boolean).join(' ').toLowerCase()
      const hiddenKeywords = [
        '社区编码',
        '小区编码',
        'community code'
      ]
      return hiddenKeywords.some(keyword => text.includes(String(keyword).toLowerCase()))
    },
    async _loadEditAttrValue(specCd, values) {
      const { data } = await getAttrValueList({ specCd, page: 1, row: 100 })
      data.forEach(item => {
        if (item.valueShow == 'Y') {
          values.push(item)
        }
      })
    }
  }
}
</script>

<style scoped>
>>> .figma-community-dialog {
  width: 650px !important;
  border-radius: 12px;
  overflow: hidden;
}

>>> .figma-community-dialog .el-dialog__header {
  height: 66px;
  padding: 0;
  background: #EBF2FA;
}

>>> .figma-community-dialog .el-dialog__body {
  padding: 24px 24px 0;
}

>>> .figma-community-dialog .el-dialog__footer {
  padding: 24px 24px 28px;
}

.figma-dialog-header {
  position: relative;
  height: 66px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  box-sizing: border-box;
}

.figma-dialog-title {
  color: #1D2129;
  font-size: 16px;
  font-weight: 600;
  font-family: 'PingFang SC', sans-serif;
  line-height: 22px;
}

.figma-dialog-divider {
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 650px;
  height: 1px;
}

.figma-community-form >>> .el-form-item {
  margin-bottom: 20px;
}

.figma-community-form >>> .el-form-item__label {
  color: #1D2129;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
  padding-right: 8px;
}

.figma-community-form >>> .el-form-item.is-required .el-form-item__label:before {
  color: #FB2C36;
  font-weight: 500;
}

.figma-form-input {
  width: 516px;
}

.figma-form-input >>> .el-input__inner {
  width: 516px;
  height: 38px;
  border: none;
  outline: 1px solid #DCE6F5;
  outline-offset: -1px;
  border-radius: 10px;
  background: #FFFFFF;
  color: #1D2129;
  font-size: 14px;
  font-family: Inter, 'PingFang SC', sans-serif;
  padding: 0 16px;
}

.figma-form-input >>> .el-input__inner:focus {
  outline-color: #0E76FF;
}

.figma-form-input >>> .el-input__inner::placeholder {
  color: #8C9BB4;
}

.figma-form-input >>> .el-input__inner[disabled] {
  background: #F5F7FA;
  color: #C0C4CC;
  cursor: not-allowed;
}

.figma-status-form-item {
  margin-bottom: 0 !important;
}

.figma-status-radio {
  height: 24px;
  display: flex;
  align-items: center;
  gap: 64px;
}

.figma-status-radio >>> .el-radio {
  color: #8C9BB4;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
  margin-right: 0;
}

.figma-status-radio >>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #0E76FF;
  background: #0E76FF;
}

.figma-status-radio >>> .el-radio__input.is-checked + .el-radio__label {
  color: #8C9BB4;
}

.figma-dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.figma-btn-cancel,
.figma-btn-confirm {
  width: 98px;
  height: 38px;
  border-radius: 10px !important;
  font-size: 14px;
  font-weight: 500;
  font-family: 'PingFang SC', sans-serif;
  padding: 0 !important;
}

.figma-btn-cancel {
  border: none !important;
  outline: 1px solid #0E76FF !important;
  outline-offset: -1px;
  background: #FFFFFF !important;
  color: #0E76FF !important;
}

.figma-btn-confirm {
  border: none !important;
  background: #0E76FF !important;
  color: #FFFFFF !important;
}
</style>
